<template>
  <div>
    <div class="page-container">
      <QrDetail variant="modal" />
      <el-row class="user-main">
        <el-col :span="5">
          <div class="user-info">
            <div class="avatar-box-b">
              <div class="avatar-main">
                <el-image :src="info.author_photo" fit="cover">
                  <div slot="error" class="image-slot">
                    <img src="../../assets/image/morentx.jpg" alt="">
                  </div>
                </el-image>
              </div>
            </div>
            <div class="artinfo">
              <h3 class="name">{{info.author_name}}</h3>
              <div class="tools">
                <p class="tools-l"><span>作品<span>{{info.product_count || 0}}</span></span><span>粉丝<span>{{info.like_count || 0}}</span></span></p>
                <div class="tools-r">
                  <el-button type="primary" @click="handleAddArtlike(info.author_id)" :icon="info.is_like?'':'el-icon-plus'" plain>{{info.is_like?"取消关注":"关注"}}</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="desc" v-html="info.remark"></div>
        </el-col>
      </el-row>
      <div style="margin-top:20px">
        <Panel :title="'在拍作品'" :plain="false">
          <ProList :page="true" :pro-desc="true" :list="list" @nextPageTarget="getArtistInfo" :isend="isend"></ProList>
        </Panel>
      </div>

    </div>
  </div>
</template>
<style lang="scss" scoped>
.user-main {
  padding: 20px 15px;
  box-shadow: 0px 0px 8px 0px #e0e0e0;
  border-radius: 8px;
  position: relative;
  margin-top: 120px;
}
.user-info {
  position: relative;
  padding-top: 45px;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
}
.avatar-box-b {
  padding: 6px;
  position: absolute;
  top: -80px;
  left: 50%;
  margin-left: -66px;
  background-color: #ebebeb;
  border-radius: 50%;
  overflow: hidden;
}
.avatar-main {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  .el-image {
    width: 100%;
    height: 100%;
  }
}
.tools-l {
  color: #999;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  > span {
    max-width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    &:first-child {
      margin-right: 10px;
    }
  }
}
.desc {
  text-indent: 2em;
  padding: 0px 10px;
  margin-left: 25px;
  color: #999;
  line-height: 1.5555;
  font-size: 14px;
  height: 13.5em;
  overflow-y: auto;
  text-align: justify;
}
</style>
<script>
import Panel from '../../components/panel.vue';
import ProList from '../../components/prolist.vue';
import QrDetail from '../../components/qrdetail.vue';
import {
  ArtistAPI
} from "../../model/artist.js";
let artistAPI = new ArtistAPI();
export default {
  name: 'index',
  data() {
    return {
      id: this.$route.query.id,
      pageIndex: 1,
      pageSize: 8,
      videoType: 0,//0只获取专场作品，1获取全部
      info: {},
      isend: false,
      list: []
    }
  },
  components: {
    Panel,
    ProList,
    QrDetail
  },
  created() {
    this.getArtistInfo()
  },
  methods: {
    getArtistInfo() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        artistAPI.artistInfo({
          AuthorID: _this.id,
          CustomerID: _this.user ? _this.user.id : "",
          PageIndex: _this.pageIndex,
          PageSize: _this.pageSize,
          Type: _this.videoType
        }).then((res) => {
          _this.info = res;
          let list = res.listProduct;
          if (list.length < _this.pageSize || list.length == 0) {
            _this.isend = true
          }
          _this.list = list.length > 0 ? _this.list.concat(list) : _this.list;
          _this.pageIndex++;
          resolve();
        }, () => {
          reject();
        })
      })
    },
    handleAddArtlike(id) {
      let _this = this;
      _this.addLike(id).then(() => {
        if (!_this.info.is_like) {
          _this.info.is_like = true
        } else {
          _this.info.is_like = false
        }
        _this.$message({
          message: '操作成功',
          type: 'success'
        });
      })
    }
  }
}
</script>